import React, { useState } from "react";
import { Button, Tooltip } from "antd";
import { CopyOutlined, DeleteOutlined } from "@ant-design/icons";
import DuplicateModal from "./DuplicateModal.tsx";
import DeleteModal from "./DeleteModal.tsx";

interface ConfigurationToolbarProps {
  configurationId: string;
  configurationList: { id: string; displayName: string }[];
  onRefresh?: () => void;
}

const ConfigurationToolbar: React.FC<ConfigurationToolbarProps> = ({
  configurationId,
  configurationList,
  onRefresh,
}) => {
  const [isDuplicateModalVisible, setIsDuplicateModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const handleDuplicate = () => setIsDuplicateModalVisible(true);
  const handleCloseDuplicateModal = () => setIsDuplicateModalVisible(false);

  const handleDelete = () => setIsDeleteModalVisible(true);
  const handleCloseDeleteModal = () => setIsDeleteModalVisible(false);

  return (
    <>
      <div className="toolbar">
        <Tooltip title="Copy Configuration">
          <Button icon={<CopyOutlined />} onClick={handleDuplicate} data-testid="duplicate-button"/>
        </Tooltip>
        <Tooltip title="Delete Configuration">
          <Button danger icon={<DeleteOutlined />} onClick={handleDelete} data-testid="delete-button"/>
        </Tooltip>
      </div>

      <DuplicateModal
        configurationId={configurationId}
        visible={isDuplicateModalVisible}
        onClose={handleCloseDuplicateModal}
        onDuplicateSuccess={() => {
          handleCloseDuplicateModal();
          onRefresh?.();
        }}
        configurationList={configurationList}
      />

      <DeleteModal
        configurationId={configurationId}
        visible={isDeleteModalVisible}
        onClose={handleCloseDeleteModal}
        onDeleteSuccess={() => {
          onRefresh?.();
        }}
      />
    </>
  );
};

export default ConfigurationToolbar;
